import React, { useRef, useEffect, useState } from "react";
import { image } from "../assets";
import { getProfile, uploadImage, updateProfile } from "../constants";
import { useNavigate } from "react-router-dom";
import ModalEditPhoto from "./modals/ModalEditPhoto";
import ModalChangePassword from "./modals/ModalChangePassword";

const SettingAccount = ({ token }) => {
  const inputFile = useRef(null);
  const user = JSON.parse(localStorage.getItem("user_info"));
  const navigate = useNavigate();
  const email = user.email;
  const [loading, setLoading] = useState(false);
  const [profilePicture, setProfilePicture] = useState(user.profile.image.url);
  const [profilePictureId, setProfilePictureId] = useState(
    user.profile.image.id,
  );
  const [phoneNumber, setPhoneNumber] = useState(user.phone_number);
  const [imageEdit, setImageEdit] = useState(profilePicture);
  const [fullName, setFullName] = useState(user.fullname ? user.fullname : "");
  const accountParams = [
    { label: "Email", value: email, isDisabled: true },
    { label: "Phone number", value: phoneNumber, funcSet: setPhoneNumber },
    { label: "Full name", value: fullName, funcSet: setFullName },
  ];

  const handleOnChange = (e, funcSet) => {
    e.preventDefault();
    funcSet(e.target.value);
  };

  useEffect(() => {
    getProfile(
      token,
      setFullName,
      setProfilePicture,
      setProfilePictureId,
      setPhoneNumber,
    );
  }, []);

  const handleOnChangeImage = (e) => {
    e.preventDefault();
    let file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();

    reader.addEventListener("load", () => {
      const imageUrl = reader.result?.toString() || "";
      setImageEdit(imageUrl);
    });
    reader.readAsDataURL(file);
    document.getElementById("edit_photo_modal").showModal();
  };

  const handleOnClickUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    let profileImage = null;
    if (
      profilePicture &&
      !profilePicture.startsWith("https://cdn.nitomeyocard.com")
    ) {
      profileImage = await uploadImage(token, profilePicture, "profile");
    } else if (profilePicture) {
      profileImage = profilePictureId;
    }
    const data = {
      email: email,
      fullname: fullName != "" ? fullName : null,
      phone_number: phoneNumber != "" ? phoneNumber : null,
      profile_image_id: profileImage,
    };
    const success = await updateProfile(token, data, setLoading);
    if (success) {
      const profileData = await getProfile(
        token,
        setFullName,
        setProfilePicture,
        setProfilePictureId,
        setPhoneNumber,
      );
      if (profileData) {
        const user = JSON.parse(localStorage.getItem("user_info"));
        user.profile = profileData;
        localStorage.setItem("user_info", JSON.stringify(user));
        navigate("/settings?tab=account");
      }
    }
  };

  return (
    <div className="flex flex-col w-full gap-5">
      <div className="font-bold">Account</div>
      <div className="flex flex-col gap-3">
        {accountParams.map((val, ind) => (
          <div key={ind} className="flex flex-row w-full items-center">
            <div className="flex flex-col w-4/12">{val.label}</div>
            <input
              className={`flex flex-col border border-black rounded-lg w-2/3 md:w-1/2 h-[40px] px-3 ${
                val.isDisabled ? "bg-gray-200 cursor-not-allowed" : ""
              }`}
              value={val.value}
              disabled={val.isDisabled}
              onChange={(e) => handleOnChange(e, val.funcSet)}
              type={"text"}
            />
          </div>
        ))}
        <div className="flex flex-row w-full items-center">
          <div className="flex flex-col w-1/3">Profile picture</div>
          <input
            type="file"
            accept="image/*"
            id="header"
            ref={inputFile}
            className="hidden"
            onChange={handleOnChangeImage}
          />
          <div className="flex flex-col gap-2 w-1/2">
            {profilePicture ? (
              <div className="flex flex-col">
                <img
                  src={profilePicture}
                  alt="header"
                  className="w-[150px] h-[150px]"
                />
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center gap-3 w-[150px] h-[150px] bg-gray-200 rounded-lg">
                <img src={image} alt="" className="h-8" />
                <div>Add image</div>
              </div>
            )}
            <div className="flex flex-row gap-4">
              <div
                className={`px-4 py-1 bg-primary hover:bg-tertiary cursor-pointer text-[16px] font-regular text-white w-fit rounded-lg`}
                onClick={(e) => inputFile.current.click()}
              >
                {profilePicture ? "Edit" : "Upload"}
              </div>
              {profilePicture ? (
                <div
                  className="px-4 py-1 bg-red-900 text-[16px] font-regular cursor-pointer text-white w-fit rounded-lg hover:bg-tertiary"
                  onClick={(e) => {
                    e.preventDefault();
                    setProfilePicture(null);
                  }}
                >
                  Delete
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div
          className="flex flex-col items-center justify-center py-2 text-center rounded-lg bg-primary hover:bg-secondary cursor-pointer text-white w-[200px]"
          onClick={handleOnClickUpdateProfile}
        >
          {loading ? (
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="white"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="#E47410"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Update Profile"
          )}
        </div>
        <div className="flex flex-row w-full items-center mt-10">
          <div className="flex flex-col w-1/3">Password</div>
          <div
            className="flex flex-col px-4 w-fit bg-primary py-2 text-white rounded-lg hover:bg-tertiary cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("change_password_modal").showModal();
            }}
          >
            Change Password
          </div>
        </div>
      </div>
      <ModalEditPhoto
        imgsrc={imageEdit}
        setImgSrc={setProfilePicture}
        aspect={1}
        circularCrop={true}
      />
      <ModalChangePassword email={email} />
    </div>
  );
};

export default SettingAccount;
